import { render, staticRenderFns } from "./btn-outline-active.mpx?vue&type=template&id=74983fba&isComponent&outputPath=components%2Fbtn-outline-active60e6c3ea%2Findex"
import script from "./btn-outline-active.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-outline-active60e6c3ea%2Findex"
export * from "./btn-outline-active.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-outline-active60e6c3ea%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports